import { Link } from "react-router-dom";
import RedirectIcon from "../../../../../../assets/Icons/Universal/RedirectIcon.svg";
import { useRef, useEffect, useState } from "react";

const statusColor = {
  completed: "successGreen",
  postponed: "folderColor",
  cancelled: "redColor",
};

const ExamHistoryCards = ({
  examName = "",
  startDate,
  endDate,
  classes,
  path = "",
}) => {
  const testRef = useRef(null);
  const [height, setHeight] = useState("auto");

  useEffect(() => {
    if (testRef.current) {
      setHeight(testRef.current.getBoundingClientRect().height + "px");
    }
  }, [classes]);

  return (
    <tr>
      <td ref={testRef}>
        <div
          style={{ height }}
          className="flex-col align-start justify-start g-05"
        >
          <span className="f-16 poppins">{examName}</span>
          <div className="flex-row align-center justify-start g-05">
            <span className="t-13 poppins color-grayColor">
              {startDate} - {endDate}
            </span>
            {path !== "" && (
              <Link
                to={path}
                className="flex-row align-center justify-start g-05"
                style={{ textDecoration: "none" }}
              >
                <span className="t-13 poppins color-blueColor1">Details</span>
                <img src={RedirectIcon} alt="redirect" />
              </Link>
            )}
          </div>
        </div>
      </td>

      {/* Participating Classes */}
      <td>
        <div
          className="flex-col align-start justify-start g-1"
          style={{ height }}
        >
          {classes?.map((data, idx) => (
            <span
              key={`class-${idx}`}
              className="t-14 color-greenColor poppins text-align-left"
            >
              {data?.className}
            </span>
          ))}
        </div>
      </td>

      {/* Status */}
      <td>
        <div
          className="flex-col align-start justify-start g-1"
          style={{ height }}
        >
          {classes?.map((data, idx) => {
            const statusKey = data?.status?.toLowerCase();
            return (
              <span
                key={`status-${idx}`}
                className={`t-14 poppins text-align-left color-${
                  statusColor[statusKey] || "grayColor"
                }`}
              >
                {data?.status}
              </span>
            );
          })}
        </div>
      </td>

      {/* Exam Routine (placeholder) */}
      <td className="t-14 color-greenColor poppins text-align-center">
        <div
          className="flex-col align-start-justify-start g-05"
          style={{ height }}
        >
          {classes?.map((_, idx) => (
            <button
              key={`routine-${idx}`}
              className="blueActionBtnLight p-05"
              style={{
                padding: "6px 29px",
                height: "fit-content",
                border: "none",
              }}
            >
              View routine
            </button>
          ))}
        </div>
      </td>

      {/* Exam Result (placeholder) */}
      <td className="t-14 color-greenColor poppins text-align-center">
        <div
          className="flex-col align-start-justify-start g-05"
          style={{ height }}
        >
          {classes?.map((data, idx) =>
            data?.result === "View result" ? (
              <button
                key={`result-${idx}`}
                className="actionBtnLight"
                style={{
                  padding: "6px 29px",
                  height: "fit-content",
                  border: "none",
                  width: "132px",
                }}
              >
                {data?.result}
              </button>
            ) : (
              <span
                key={`result-${idx}`}
                className="back-borderGray radius-6 color-grayColor t-12 poppins-medium text-no-wrap"
                style={{
                  padding: "6px 29px",
                  height: "fit-content",
                  border: "none",
                  textAlign: "center",
                  width: "132px",
                  cursor: "not-allowed",
                }}
              >
                {data?.result || "Not published"}
              </span>
            )
          )}
        </div>
      </td>
    </tr>
  );
};

export default ExamHistoryCards;
